module.exports = __webpack_public_path__ + "img/news_02.5288a466.jpg";